import React from "react";
import PropTypes from "prop-types";
import invoiceService from "../../services/invoiceService"; // Use invoiceService instead of reviewService

const ToggleReviewButton = ({ invoiceId, reviewed, onReviewToggled }) => {
    const handleClick = async () => {
        try {
            const updatedInvoice = await invoiceService.toggleReviewStatus(invoiceId); // Use invoiceService
            onReviewToggled(updatedInvoice); // Notify parent component of the updated invoice
        } catch (error) {
            console.error("❌ Error toggling review status:", error);
        }
    };

    return (
        <button
            style={{
                backgroundColor: reviewed ? "#28a745" : "#dc3545",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
            }}
            onClick={handleClick}
        >
            {reviewed ? "Mark as Unreviewed" : "Mark as Reviewed"}
        </button>
    );
};

ToggleReviewButton.propTypes = {
    invoiceId: PropTypes.string.isRequired,
    reviewed: PropTypes.bool.isRequired,
    onReviewToggled: PropTypes.func.isRequired,
};

export default ToggleReviewButton;
